"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var campusForm_component_1 = require("./campusForm.component");
exports.AsherCampusForm = campusForm_component_1.AsherCampusForm;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInZpZXdzL0FzaGVyL3BhcnRzL2NhbXB1c0Zvcm0vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrREFBc0Q7QUFBOUMsaURBQUEsZUFBZSxDQUFBIn0=